<script>
  import UserMapsItem from "./UserMapsItem.svelte";
  import { db } from "../firebase";
  import { collectionData } from "rxfire/firestore";
  import { combineLatest } from 'rxjs';
  import { startWith } from "rxjs/operators";
  import Add16 from "carbon-icons-svelte/lib/Add16";

  //User ID passed from parent
  export let uid;
  export let email;
  let shared = true;
  
  // let domain = email.split("@").pop()
  let domain = email.split("@").pop().split('.').join('')

  //Form Text
  let title = "";
  let description ="Add a description";
  //map template
  let map = [
    {
      id: 1,      
      cs: 65,
      fp: 0,
      title: "Step 1",
      description: "",
      fpText: "",
      thumb: ""
    },
    {
      id: 2,      
      cs: 85,
      fp: 0,
      title: "Step 2",
      description: "",
      fpText: "",
      thumb: ""
    }
  ];

  //Query requires and index, see screenshot below
  const query = db
    .collection("maps")
    .where("uid", "==", uid)
    .orderBy("created","desc");

  const maps = collectionData(query, "id").pipe(startWith([]));
  let sharedMaps 

  if (email) {
    console.log("checking for matches for " + domain);
    let domainQuery = db.collection('domains').doc(domain)
    domainQuery.get()
      .then(doc => {        
        console.log(doc.exists);
        if (doc.exists && doc.data().shared === true) {
          console.log(domain + " is shared");
          const queryDomains = db.collection("maps")
            .where("domain", "==", domain)
            .where("uid", "!=", uid)
            .where("shared", "==", true)
            .orderBy("uid","asc")
            .orderBy("created","desc")
            // .get()
            // .then(sharedDocs => {
            //   console.log("GOT JOHN's MAP");
            //   console.log(sharedDocs);
            // });        
          sharedMaps = collectionData(queryDomains, "id").pipe(startWith([]));      
        }       
      })
  }

  function add() {
    if (title == "") {
      title = "Untitled";
    }
    db.collection("maps").add({ uid, email, domain, title, description, map, shared, created: Date.now() });
    title = "";
  }

  function updateStatus(event) {
    const { id, newStatus } = event.detail;
    db.collection("maps")
      .doc(id)
      .update({ complete: newStatus });
  }

  function removeNotAllowed() {
    alert("Sorry, you cannot remove maps that were created by a team member.")
  }

  function removeItem(event) {
    const { id } = event.detail;
    db.collection("maps")
      .doc(id)
      .delete();
  }
</script>

<style>
  input {    
    @apply block;
  }

  .usermaps {
    @apply p-0 grid gap-4;
    grid-template-columns: repeat(auto-fill, minmax(200px, 5fr));
  }

  .mapinput {
    @apply border rounded-sm w-full p-2;
 
  }
</style>
<h1 class="text-2xl font-bold mb-4">Your Journey Maps</h1>
<div class="usermaps m-0">

  <div class="card empty">
    <div class="cardtop">
      <p>
        <strong>Add a map</strong>
      </p>
      <input class="mapinput" bind:value={title} placeholder="Map Title" />
    </div>
    <div class="cardactions">
      <button class="button" on:click={add}>
        <Add16 class="buttonicon" />
      </button>
    </div>
  </div>

  {#each $maps as map}
    <!-- <pre>{JSON.stringify(map, null, '  ')}</pre> -->
    <UserMapsItem {...map} on:remove={removeItem} />   
  {/each}

  
</div>

{#if $sharedMaps && $sharedMaps.length > 0}
  <h1 class="text-2xl  mt-8 font-bold mb-4">Shared Maps</h1>
  <div class="usermaps">
    {#each $sharedMaps as sm}    
      <UserMapsItem {...sm} showAuthor={true} owned={false} on:remove={removeNotAllowed} />   
    {/each}
  </div>
{/if}